import React, { useEffect, useState } from 'react';
import { UtilityService } from '../../../services/UtilityService';

interface Props {
    more?: boolean;
    MediaUrl: string;
    text?: boolean;
    mediaDisplay?: () => void;
    fileDownload?: () => void;
    classname?: any;
}

const ImageComponent = (props: Props) => {
    const [Url, SetUrl] = useState("");
    const [whRatio, SetWhRatio] = useState(0);

    useEffect(() => {
        UtilityService.convertUrlToBlob(props.MediaUrl).then(res => {
            let img = new Image();
            img.src = res;
            img.onload = () => {
                SetUrl(res);
                SetWhRatio(img.width / img.height);
            }
        });
    }, [props.MediaUrl])

    const handleOnClick = (event: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        event.preventDefault();
        props.mediaDisplay?.call(props);
    }

    return (
        <div className='d-flex justify-center align-center'>
            {whRatio < 1 ?
                <img src={Url} className={props.classname} onClick={handleOnClick} style={{ backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "cover" }} /> :
                <img src={Url} className={props.classname} onClick={handleOnClick} style={{ backgroundPosition: "center", backgroundRepeat: "no-repeat", backgroundSize: "contain" }} />
            }
        </div>
    )
}

export default ImageComponent;


